import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { FloatLabelModule } from 'primeng/floatlabel';


@Component({
  selector: 'primeng-floatlabel-wrapper',
  imports:[FloatLabelModule],
  template: `
    <div class="mb-2 mt-4">
        <p-floatlabel variant="on">
            <label [for]="key">{{ props.label }}</label>
            <ng-container #fieldComponent></ng-container>
        </p-floatlabel>
    </div>
  `,
})
export class PrimeNGFloatLabelWrapper extends FieldWrapper {
}